import { addDays } from 'date-fns'
import { HttpClient, buildParams, queryString } from '@opallabs/api'
import { loadJsonApiEntities } from '../../loadJsonApiEntities'

const fetchContent = (params) => {
  const builtParams = buildParams({
    filter: { ...params.filter },
    include: params.include,
    omit_count: Boolean(params.omitCount),
    page: params.page,
    sort: params.sort,
    ...params.fields,
  })

  const url = new URL('/content/v2', window.location.origin)
  url.search = queryString(builtParams.params)

  return HttpClient().get(url.toString())
}

const buildFilters = ({
  accountIds,
  brandId: brand_id,
  includeOverlappingSchedules: include_overlapping_schedules,
  labelIds,
  postStatuses,
  scheduledEndAt: scheduled_end_at = addDays(new Date(), 6),
  scheduledStartAt: scheduled_start_at = new Date(),
  serviceIds,
  storyIds,
  useWorkflowStartedAt: use_workflow_started_at,
}) => {
  const filter = {
    brand_id,
    include_overlapping_schedules,
    scheduled_end_at,
    scheduled_start_at,
    use_workflow_started_at,
  }

  if (accountIds && accountIds.length) filter.account_ids = accountIds
  if (labelIds && labelIds.length) filter.label_ids = labelIds
  if (postStatuses && postStatuses.length) filter.post_statuses = postStatuses
  if (serviceIds && serviceIds.length) filter.service_id = serviceIds.join(',')
  if (storyIds && storyIds.length) filter.story_ids = storyIds

  return filter
}

const buildSort = (groupBy) => {
  switch (groupBy) {
    case 'Channel':
      return 'service'
    case 'Account':
      return 'account'
    default:
      return 'moment,position'
  }
}

const getContentV2 = (params) => (dispatch) => {
  const { brandId: brand_id, groupBy, omitCount = false, page = 1 } = params

  const filter = buildFilters(params)
  const sort = buildSort(groupBy)
  const include = params.include || []
  const fields = params.fields || {}

  return fetchContent({
    brand_id,
    fields,
    filter,
    include,
    omitCount,
    page,
    sort,
  })
    .then((response) => dispatch(loadJsonApiEntities(response.data)))
    .catch((err) => {
      console.log(err)
      throw err
    })
}

export default getContentV2
